import { isInWishlist, onWishlistChange, toggleWishlist } from '@theme/wishlist';

/**
 * Heart button that adds/removes a product from the wishlist.
 * Markup: <wishlist-toggle data-product-handle="..."><button aria-pressed>...</button></wishlist-toggle>
 * An optional [data-wishlist-label] element shows `data-label-add` / `data-label-remove` text.
 */
class WishlistToggle extends HTMLElement {
  /** @type {(() => void) | undefined} */
  #unsubscribe;

  connectedCallback() {
    this.button?.addEventListener('click', this.#onClick);
    this.#unsubscribe = onWishlistChange(this.#sync);
    this.#sync();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#onClick);
    this.#unsubscribe?.();
  }

  /** @returns {HTMLButtonElement | null} */
  get button() {
    return this.querySelector('button');
  }

  get handle() {
    return this.dataset.productHandle ?? '';
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.handle) toggleWishlist(this.handle);
  };

  #sync = () => {
    const saved = isInWishlist(this.handle);
    this.button?.setAttribute('aria-pressed', String(saved));

    const label = this.querySelector('[data-wishlist-label]');
    if (label instanceof HTMLElement) {
      const text = saved ? label.dataset.labelRemove : label.dataset.labelAdd;
      if (text) label.textContent = text;
    }
  };
}

if (!customElements.get('wishlist-toggle')) {
  customElements.define('wishlist-toggle', WishlistToggle);
}
